import './kchoppsrd/style';
import FormStructure from './kchoppsrd/form_structure';

export default FormStructure;